<template>
  <div>
    <v-select
      v-model="cuentaBancaria"
      label="Cuenta bancaria"
      :items="cuentasBancarias"
      item-text="descripcion"
      return-object
      @change="change"
      :clearable="clearable"
    />
  </div>
</template>
<script>
import axios from "axios";

export default {
  props: { clearable: { type: Boolean, default: false } },
  data() {
    return {
      cuentaBancaria: null,
      cuentasBancarias: [],
    };
  },
  mounted() {
    axios
      .get("/pago/cuentasBancarias")
      .then((response) => {
        console.log(response);
        this.cuentasBancarias = response.data.map((cb) => ({
          id: cb.id,
          descripcion: cb.banco.descripcion + " - " + cb.numero,
        }));
      })
      .catch((err) => {
        if (err && err.response && err.response.data) {
          this.errorMessage = err.response.data;
        } else {
          this.errorMessage = "Error";
        }
      });
  },
  methods: {
    change() {
      this.$emit("change", this.cuentaBancaria);
    },
  },
};
</script>